import React, { useState } from 'react'
import { Button, Alert } from 'reactstrap'
import { post } from '../BackendClient'

export function WakeOnLan() {
	const [status, setStatus] = useState(null)
	const [loading, setLoading] = useState(false)

	async function handleWake() {
		setLoading(true)
		setStatus(null)
		try {
			const response = await post('wakeonlan/wake')
			if (response.status === 200) {
				setStatus({ message: 'Wake-on-LAN packet sent!', color: 'success' })
			} else {
				const text = await response.text()
				setStatus({ message: `Error: ${text}`, color: 'danger' })
			}
		} catch {
			setStatus({ message: 'Failed to reach server.', color: 'danger' })
		}
		setLoading(false)
	}

	return (
		<div>
			<h2>Wake on LAN</h2>
			<p>
				Target device: <code>D8:BB:C1:60:95:99</code>
			</p>
			{status && <Alert color={status.color}>{status.message}</Alert>}
			<Button color="primary" onClick={handleWake} disabled={loading}>
				{loading ? 'Sending...' : 'Wake Device'}
			</Button>
		</div>
	)
}
